<template>
    <div :class="'box-item box-item--' + boxItemClass + (columnsNumber == 1 ? ' column-full-width' : '')">
        <h2>YOUR {{currentOrNext()}} {{entryType | pluralize(entries.length) | uppercase}} - {{time()}}</h2>
        <div :class="'box-item__inner-wrapper box-item__inner-wrapper-col-' + columnsNumber">
            <div class="box-item__col" v-for="(entry, index) in entries" :key="index">
                <div class="box-item__col-inner-wrapper">
                    <WhatsHappeningEntry :entry="entry" />
                    <h3 class="please-go-to-stand" v-if="showGoToStandMessage(entry)">PLEASE GO TO {{meetingPlace(entry)}}</h3>
                    <WhatsHappeningEntryJoinButton v-if="tellAttendeeToGoToTheMeeting" :entry="entry" :tellAttendeeToGoToTheMeetingAt="tellAttendeeToGoToTheMeetingAt" :closeToEntry="closeToEntry"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WhatsHappeningEntry from './WhatsHappeningEntry'
import WhatsHappeningEntryJoinButton from './WhatsHappeningEntryJoinButton'

const minutesBeforeToEnableJoinButton = 2

export default {
  name: 'WhatsHappeningEntriesBox',
  props: ['isCurrent', 'entries', 'tellAttendeeToGoToTheMeeting', 'boxItemClass'],
  components: {WhatsHappeningEntry, WhatsHappeningEntryJoinButton},
  created() {
    this.tellAttendeeToGoToTheMeetingAt = new Date(new Date(this.entries[0].starts_at) - minutesBeforeToEnableJoinButton * 60 * 1000)
  },
  computed: {
    columnsNumber() {
      return this.entries.length
    },
    entryType() {
      return this.entries[0] && this.entries[0].type
    },
    closeToEntry() {
      return this.$store.state.currentTime >= this.tellAttendeeToGoToTheMeetingAt
    },
  },
  methods: {
    showGoToStandMessage(entry) {
      return this.$store.state.event.meetings_are_hosted_by
      && this.$store.state.attendee.type != this.$store.state.event.meetings_are_hosted_by
      && this.tellAttendeeToGoToTheMeeting
      && !entry.online
      && this.closeToEntry
      && entry.type == 'meeting'
    },
    time() {
      let firstEntry = this.entries[0]
      return `${firstEntry.starts_at.slice(11,16)} - ${firstEntry.ends_at.slice(11,16)}`
    },
    currentOrNext() {
      if (this.entryType == 'registration') {
        return ''
      } else {
        return (this.isCurrent ? 'CURRENT' : 'NEXT')
      }
    },
    meetingPlaceType() {
      if (this.$store.state.event.meetings_are_hosted_by == 'delegate') {
        return 'BOOTH'
      } else {
        return 'STAND'
      }
    },
    meetingPlace(entry) {
      return `${entry.title.toUpperCase()}'S ${this.meetingPlaceType()}`
    }

  }
}
</script>

<style>
h3.please-go-to-stand {
  font-weight: 100;
  margin-top: 20px;
  line-height: 1.2em;
}
</style>
